import React from 'react';

interface NavbarProps {
  onRegisterClick: () => void;
}

const Navbar: React.FC<NavbarProps> = ({ onRegisterClick }) => {
  return (
    <nav className="sticky top-0 z-50 w-full bg-white shadow-sm border-b border-gray-100 py-3">
      <div className="mx-auto flex max-w-7xl items-center justify-between px-4 md:px-12">
        
        {/* Brand Section */}
        <div className="flex items-center gap-3">
            <div className="flex flex-col leading-none">
              <span className="text-xl font-black tracking-tight text-gray-900 md:text-2xl">
                VIDYAPEETH
              </span>
              <span className="text-[10px] font-bold text-[#9e1c22] uppercase tracking-widest md:text-[11px]">
                IIT-JEE | NEET | FOUNDATION
              </span>
            </div>
        </div>

        {/* Register Button */}
        <button 
          onClick={onRegisterClick}
          className="rounded-lg bg-[#9e1c22] px-6 py-2.5 text-xs font-bold text-white shadow-lg transition-all hover:bg-red-800 hover:shadow-red-500/30 active:scale-95 md:text-sm uppercase tracking-wider"
        >
          Registration
        </button>
      </div>
    </nav>
  );
};

export default Navbar;